/** @format — Documents empty state */

export default function DocumentsEmptyState() {
  return (
    <div className="flex w-full flex-col items-center px-4 pt-16 md:px-5 md:pt-[100px] lg:px-8">
      <img
        src="/closed-document.svg"
        alt=""
        className="h-[152px] w-[170px] object-contain"
        aria-hidden
      />
      <div className="mt-6 flex max-w-md flex-col items-center gap-1 px-4">
        <p className="text-center text-base font-medium text-[#11121a]">
          You don&apos;t have any documents yet
        </p>
        <p className="text-center text-sm text-neutral-500">
          Documents related to your shipments will be shown here
        </p>
      </div>
    </div>
  );
}
